import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ExamdojoAuthService, LastUsedAuthService } from '@examdojo/auth';
import { distinctUntilChanged, filter, switchMap, tap } from 'rxjs';

@Injectable()
export class SaveLastUsedAuthEffect {
  constructor(
    private readonly authService: ExamdojoAuthService,
    private readonly lastUsedAuthService: LastUsedAuthService,
  ) {
    // Listen for successful sign-ins and save the provider
    this.authService.currentUser$
      .pipe(
        distinctUntilChanged(),
        filter(Boolean),
        switchMap(() => this.authService.selectAuthProvider()),
        filter(Boolean),
        tap((provider) => {
          this.lastUsedAuthService.setLastUsedMethod(provider);
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
